import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'

import SHSForm from '../utils/shs-form'
import InputElement from '../utils/input'

import { callApi } from '../../actions/api'
import { apiResourceEndpoint, routes } from '../../constants/routes'

import * as MASKS from '../utils/input-masks'

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth
    }
}

const CreateUser = ({ dispatch, user }) => {
    const userId = user?.id ? user.id : null
    const readyToRoute = useMemo(() => {
        if (userId && userId > 0) {
            return true
        }
        return false
    }, [userId])
    // const [ readyToRoute, setReadyToRoute ] = useState(false)

    // if (user && 'id' in user && user.id > 0) {
    //     setReadyToRoute(true)
    // }

    const successFX = () => {
        // setReadyToRoute(true)
    }

    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint('users', 'CREATE'), formData, formId))
    }

    if (readyToRoute) {
        return <Navigate to={routes.router} />
    }

    return (
        <div className="box m-auto w-50 mt-5">
            <h1>User Information</h1>
            <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Save">
                <InputElement
                    type="text"
                    default=""
                    id="firstName"
                    label="First Name"
                    placeholder="Ty"
                    required />
                <InputElement
                    type="text"
                    default=""
                    id="lastName"
                    label="Last Name"
                    placeholder="Cobb"
                    required />
                <InputElement
                    type="phone"
                    default=""
                    id="phone"
                    label="Phone Number"
                    isFormatted={true}
                    formatMask={MASKS.phoneMask}
                    placeholder="(123) 456-7890" />
                <InputElement
                    type="text"
                    default=""
                    id="postal"
                    label="Postal Code"
                    placeholder="78701" />
            </SHSForm>
        </div>
    )
}

export default connect(mapStateToProps)(CreateUser)
